export default __webpack_public_path__ + "static/media/profile_summary.8692930c.svg";